import type { IconNode } from '../types';

/**
 * @name whale
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggOS4xVjVhMiAyIDAgMCAwLTQgMCIgLz4KICA8cGF0aCBkPSJNMTggNWEyIDIgMCAwIDEgNCAwIiAvPgogIDxwYXRoIGQ9Ik02IDkuNyAzLjkgOC40QzIuNyA3LjcgMiA2LjQgMiA1VjNjMiAwIDQgMiA0IDJzMi0yIDQtMnYyYzAgMS40LS43IDIuNy0xLjkgMy40bC0zLjggMi40QTUgNSAwIDAgMCA3IDIwaDEyYzEuNyAwIDMtMS4zIDMtM3YtM2MwLTIuOC0yLjItNS01LTUtMi43IDAtNS4xIDEuNC02LjQgMy42TDkuNyAxNEEyIDIgMCAwIDEgNiAxM1oiIC8+CiAgPHBhdGggZD0iTTE1IDE1aC4wMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/whale
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const whale: IconNode = [
  ['path', { d: 'M18 9.1V5a2 2 0 0 0-4 0', key: '6vcw4j' }],
  ['path', { d: 'M18 5a2 2 0 0 1 4 0', key: '1vh2uv' }],
  [
    'path',
    {
      d: 'M6 9.7 3.9 8.4C2.7 7.7 2 6.4 2 5V3c2 0 4 2 4 2s2-2 4-2v2c0 1.4-.7 2.7-1.9 3.4l-3.8 2.4A5 5 0 0 0 7 20h12c1.7 0 3-1.3 3-3v-3c0-2.8-2.2-5-5-5-2.7 0-5.1 1.4-6.4 3.6L9.7 14A2 2 0 0 1 6 13Z',
      key: 'inpau9',
    },
  ],
  ['path', { d: 'M15 15h.01', key: 'lqbp3k' }],
];

export default whale;
